module.exports = __webpack_public_path__ + "img/small-4.f015f076.webp";